<template>
    <div>
      <q-dialog position="right" v-model="dialog">
        <q-card style="min-width: 1200px !important; height: 95vh">
          <q-card-section>
            <div class="row">
              <div class="d-flex col-12 q-pa-md pt-0" style="justify-content: space-between; align-items: center ">
                <div>
                  <h4 style="font-size: 22px; font-weight: 300;">
                    Paid Details
                  </h4>
                </div>
                <div class="drawerButtons" style="margin-top: -10px;">
                  <q-btn @click="dialog = false" flat icon="close" round size="small"></q-btn>
                </div>
              </div>
  
              <div class="col-4 q-pa-md" style="border-right: 1px solid lightgray">
                <ul style="list-style: none">
                  <li class="py-3" style="border-bottom: 1px solid #E0E0E0">
                    <span class="bankLabel d-block">Order ID</span>
                    <h4 style="font-size: 24px; font-weight: 400">
                      {{ selectedOrderObj.orderNumber ? selectedOrderObj.orderNumber : '-' }}</h4>
                  </li>
                  <li class="py-3" style="border-bottom: 1px solid #E0E0E0">
                    <span class="bankLabel d-block">Order To</span>
                    <span>{{ selectedOrderObj.OrderBy ? selectedOrderObj.OrderBy.name : '-' }}</span>
                  </li>
                  <li class="py-3" style="border-bottom: 1px solid #E0E0E0">
                    <span class="bankLabel d-block">Order Date</span>
                    <span>{{ selectedOrderObj.updatedAt ? dateTimeFilter(selectedOrderObj.updatedAt) : '-' }}</span>
                  </li>
                  <li class="py-3" style="border-bottom: 1px solid #E0E0E0">
                    <span class="bankLabel d-block">Amount</span>
                    <span>{{ selectedOrderObj.finalAmount ? '₹' + selectedOrderObj.finalAmount : '-' }}</span>
                  </li>
                  <li class="py-3" style="border-bottom: 1px solid #E0E0E0">
                    <span class="bankLabel d-block">Status</span>
                    <span>{{ createdmap[selectedOrderObj.status] || '-' }}</span>
                  </li>
                </ul>
              </div>
  
              <div class="col-8 q-pa-md" style="height: 80vh; overflow-y: auto">
                <h6 v-if="selectedOrderObj.totalQty !== undefined && createdmap[selectedOrderObj.status] !== 'Failed'"
                  style="margin-top: -18px;margin-bottom: 10px;">
                  Total Items : {{ selectedOrderObj.totalQty ? selectedOrderObj.totalQty : 0 }}
                </h6>
                <h6 class="text-red" v-else-if="createdmap[selectedOrderObj.status] === 'Failed'">
                  Order Failed
                </h6>
                <div v-show="batch_loader">
                  <q-inner-loading :showing="true" style="top: 200px;width: 430px;height: 40px;left: 450px;">
                    <q-spinner-dots color="primary" size="50px"></q-spinner-dots>
                  </q-inner-loading>
                </div>
                <q-list bordered class="rounded-borders" v-if="productArr && productArr.length">
                  <template v-for="(product, index) in productArr" v-if="product.orderItems && product.orderItems.length">
                    <q-expansion-item :key="product.productId">
                      <template v-slot:header>
                        <q-item-section>
                          {{ product.name }}
                        </q-item-section>
                        <q-item-section side>{{ product.orderItems.length }}</q-item-section>
                      </template>
                      <q-card>
                        <q-card-section>
                          <q-list bordered padding>
                            <q-item v-for="(orderItem, i) in product.orderItems" :key="orderItem.id" class="hover-row"  @mouseover="orderItem.isHovered = true" @mouseleave="orderItem.isHovered = false">
                              <q-item-section side top>
                                <!-- You can add any content here if necessary -->
                              </q-item-section>
                              <q-item-section class="item-content">
                                <q-item-label>{{ orderItem.batch.batch }}</q-item-label>
                                <q-item-label caption>{{ product.productLineCode }}</q-item-label>
                              </q-item-section>
                              <q-item-section side top>
                                <q-btn v-if="orderItem.isHovered" @click="sendKey(orderItem.batch.id)" color="green" outline class="send-key-btn">Send Key On Mail</q-btn>
                              </q-item-section>
                            </q-item>
                          </q-list>
                        </q-card-section>
                      </q-card>
  
                    </q-expansion-item>
                  </template>
                </q-list>
              </div>
            </div>
          </q-card-section>
  
        </q-card>
      </q-dialog>
  
      <div class="row">
        <div :key="index" class="col-12 pt-0 " v-for="(order, index) in OnlineOrders">
          <q-card @click="openOrderDetail(order)" class="product-card mb-3">
            <q-card-section>
              <div class="mp-card">
                <div class="mp-header">
                  <div class="d-flex justify-content-between">
                    <div class="d-flex">
                      <div class="text-left mr-5">
                        <span class="bankLabel">Order ID</span>
                        <h4 style="font-size: 22px; line-height: 1.5rem; font-weight: 300; ">
                          {{ order.orderNumber }}
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
                <hr class="my-2" style="border: 0.5px solid lightgray">
                <div class="mp-body">
                  <ul style="list-style: none">
                    <div class="d-flex justify-content-between" style="align-items: center">
                      <div class="d-flex py-3">
                        <li>
                          <span class="bankLabel">Order To</span>
                          <div class="mp-value">
                            <span>{{ order.OrderBy ? order.OrderBy.name : '-' }}</span>
                          </div>
                        </li>
                        <li style="margin-left: 70px;">
                          <div class="">
                            <span class="bankLabel">Order Date</span>
                            <div class="d-flex ">
                              <div class="mp-value">
                                <span>{{ order.updatedAt ? dateTimeFilter(order.updatedAt) : '-' }}</span>
                              </div>
                            </div>
                          </div>
                        </li>
                        <li style="margin-left: 70px;">
                          <div class=" ">
                            <span class="bankLabel">Amount</span>
                            <div class="mp-value">
                              <span>{{ order.finalAmount ? '₹' + order.finalAmount : '-' }}</span>
                            </div>
                          </div>
                        </li>
                        <li style="margin-left: 70px;">
                          <div class="">
                            <span class="bankLabel">Status</span>
                            <div class="mp-value">
                              <span>{{ createdmap[order.status] }}</span>
                            </div>
                          </div>
                        </li>
                      </div>
                      <div class="d-flex ">
                        <span v-if="createdmap[order.status] !== 'Failed'" class="mp-item-count">{{ order.totalQty }} {{
                          order.totalQty > 1 ? 'Items' : 'Item' }}</span>
                        <span v-else class="mp-item-count text-red">Failed</span>
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
            </q-card-section>
          </q-card>
        </div>
        <div v-if="isLoading">
          <div class="row justify-center q-my-md">
            <q-spinner-dots color="primary" size="40px" />
          </div>
        </div>
      </div>
  
      <div v-if="!OnlineOrders.length">
        <img src="../../assets/no_Data.png" style="width: 25%;" class="d-block mx-auto " alt="">
        <h6 class="text-center">No data available</h6>
      </div>
  
    </div>
  </template>
  
  <script>
  import Axios from 'axios';
  import _ from 'lodash';
  
  import Constants from '../../Constants/Constant';
  
  export default {
    name: 'PaidInventoryPurchaseOnline',
    props: ['filter'],
    data: function () {
      return {
        userObj: JSON.parse(localStorage.getItem('user')),
        dialog: false,
        selectedOrderObj: '',
        OnlineOrders: [],
        productArr: [],
        batch_loader: false,
        offset: 0,
        limit: 5,
        isLoading: false,
        combineFilter: '%%',
        page: 1,
        hasMoreData: true,
        createdmap: {
          success: 'Success',
          created: 'Failed',
          failed: 'Failed'
        }
      }
    },
  
    created() {
      this.loadData();
      window.addEventListener('scroll', this.handleScroll);
    },
  
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
      sendKey(id) {
      this.$q
        .dialog({
          title: "Send Key on Mail",
          message: "Are you Sure, you want send key on mail?",
          cancel: true,
          persistent: true,
        })
        .onOk(async () => {
          const apiUrl = Constants.api_url + "sendKeyToPartner";
          const orgId = this.userObj?.organization?.id;
          const request = {
            orgId: orgId,
            batchId: id,
          };
          Axios.post(apiUrl, request)
            .then((res) => {
              if (res.data.data) {
                this.$q.notify({
                  position: "top-right",
                  message: "Batch key sent successfully.",
                });
              }
            })
            .catch(function (err) {
              console.log("Error while sending batch key.", err);
            })
            .finally(() => {
              console.log("");
            });
        });
    },
  
      async loadData() {
        if (this.isLoading || !this.hasMoreData) return;
  
        this.isLoading = true;
  
        const apiUrl = Constants.graphql_backend_url + 'rest/order/my/all';
        try {
          const response = await Axios.post(apiUrl, {
            orgId: this.userObj.orgId,
            offset: (this.page - 1) * this.limit,
            limit: this.limit,
            status:  {"_neq": "success"},
            isInvoiceSent: {}
          });
  
          console.log('response', response);
          const newItems = response.data.OnlineOrders;
          console.log('newItems', newItems);
  
          if (newItems.length > 0) {
            this.OnlineOrders = [...this.OnlineOrders, ...newItems];
          } else {
            this.hasMoreData = false;
          }
        } catch (error) {
          console.error('Error fetching data', error);
        } finally {
          this.isLoading = false;
        }
      },
      handleScroll: _.debounce(function () {
        const scrollPosition = window.innerHeight + window.scrollY;
        const documentHeight = document.body.offsetHeight;
        if (scrollPosition >= documentHeight - 200 && !this.isLoading && this.hasMoreData) {
          this.page++;
          this.loadData();
        }
      }, 300),
  
      async getOrderBatchesGroupByProduct(orderId) {
        try {
          const apiUrl = Constants.graphql_backend_url + 'rest/online/order/get';
          const response = await Axios.post(apiUrl, {
            orderId: orderId,
          });
          if (response.data && response.data.OnlineOrders_by_pk) {
            const orderData = response.data.OnlineOrders_by_pk;
            console.log('orderData',orderData);
            const orderItems = orderData.OrderItems;
            console.log('orderItems',orderItems);
            this.productArr = orderItems.map((item) => ({
              name: item.Product.name,
              productLineCode: item.Product.productLineCode,
              orderItems: item.Batch.map((batchItem) => ({
                isHovered: false,
                batch: batchItem,
              })),
            }));
          }
        } catch (error) {
          console.error('API request error', error);
          this.$q.notify('Error fetching order details');
        }
      },
      async openOrderDetail(order) {
        try {
          await this.getOrderBatchesGroupByProduct(order.id);
        } catch (error) {
          console.error('Error while opening order detail', error);
        }
        this.selectedOrderObj = order;
        this.dialog = true;
      },
    },
  }
  </script>
  
  <style scoped>
  .hover-row .item-content .send-key-btn {
    opacity: 0;
    transition: opacity 0.3s;
  }
  
  .hover-row:hover .item-content .send-key-btn {
    opacity: 1;
  }
  </style>
  